;; Generated by dev/generate_bus_routes.clj — do not edit by hand.
;; Regenerate with: devbox run generate-bus-routes
;;
;; A committed mirror of dsl/contexts/bus.edn
;; :levels :transports :models :networked-ws :routes.
;;
;; graph-ui.web.origin reads this to build the bus URL, so the page and
;; the socket keep ONE origin and ONE upgrade path. ikc.bus.ws-server
;; reads the same declaration on the server side. A path typed twice is
;; the defect this file exists to remove.

(ns graph-ui.web.generated-bus)

(def routes
  {:bundle
 {:path "/", :root "resources/public/web", :fallback "index.html"},
 :device-sign-in
 {:path "/authz/device-sign-in",
  :method :post,
  :command :authz/request-device-sign-in,
  :sets-cookie false},
 :front-door
 {:path "/site", :root "resources/public/site", :fallback :none},
 :sign-in
 {:path "/authz/sign-in",
  :method :post,
  :command :authz/sign-in,
  :sets-cookie true},
 :sign-out
 {:path "/authz/sign-out",
  :method :post,
  :command :authz/sign-out,
  :sets-cookie true},
 :upgrade {:path "/bus-ws"}}
)
